(function () {
  if (window.__lpePartnerPricesInit) return;
  window.__lpePartnerPricesInit = true;

  var BATCH = 60;
  var PROXY = '/apps/lpe/partner';
  var inflight = false;
  var queued = false;
  var timer = null;

  function formatUsdFromCents(cents) {
    if (cents == null || cents === '' || isNaN(Number(cents))) return '';
    var value = Number(cents) / 100;
    var parts = value.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function pillLabel(state) {
    if (state === 'yours') return 'Yours';
    if (state === 'held') return 'Held';
    if (state === 'sold') return 'Sold';
    return 'Available';
  }

  function fillStatusPills(sku, holdState) {
    if (!sku || !holdState) return;
    var nodes = document.querySelectorAll('[data-lpe-status-for="' + sku + '"]');
    for (var i = 0; i < nodes.length; i++) {
      var pill = nodes[i];
      pill.textContent = pillLabel(holdState);
      pill.setAttribute('data-lpe-hold', holdState);
      pill.hidden = false;
    }
  }

  function fillSlot(el, entry) {
    el.textContent = '';
    var amount = document.createElement('span');
    amount.className = 'lpe-price__amount';
    amount.textContent = formatUsdFromCents(entry.partnerPriceCents);
    el.appendChild(amount);
    if (entry.listedCents != null && entry.listedCents !== '') {
      var listed = document.createElement('span');
      listed.className = 'lpe-price__listed';
      listed.textContent = 'Retail ' + formatUsdFromCents(entry.listedCents);
      el.appendChild(listed);
    }
    var holdState = entry.holdState || 'available';
    var pill = document.createElement('span');
    pill.className = 'lpe-price__pill';
    pill.setAttribute('data-lpe-hold', holdState);
    pill.textContent = pillLabel(holdState);
    el.appendChild(pill);
    el.setAttribute('data-lpe-filled', '1');
    fillStatusPills(el.getAttribute('data-lpe-sku'), holdState);
  }

  function markUnauthorized(slots) {
    for (var i = 0; i < slots.length; i++) {
      var el = slots[i];
      el.textContent = 'Partner price after approval';
      el.setAttribute('data-lpe-filled', '1');
    }
  }

  function uniquePendingSkus() {
    var slots = document.querySelectorAll('.lpe-price[data-lpe-state="partner"][data-lpe-sku]');
    var skus = [];
    var seen = {};
    var pending = [];
    for (var i = 0; i < slots.length; i++) {
      var el = slots[i];
      if (el.getAttribute('data-lpe-filled') === '1') continue;
      var sku = (el.getAttribute('data-lpe-sku') || '').trim();
      if (!sku) continue;
      pending.push(el);
      if (!seen[sku]) {
        seen[sku] = true;
        skus.push(sku);
      }
    }
    return { skus: skus, slots: pending };
  }

  function applyPrices(prices, slots) {
    for (var i = 0; i < slots.length; i++) {
      var el = slots[i];
      var sku = el.getAttribute('data-lpe-sku');
      var entry = prices && sku ? prices[sku] : null;
      if (!entry || entry.partnerPriceCents == null) {
        el.textContent = 'Partner price on request.';
        el.setAttribute('data-lpe-filled', '1');
        continue;
      }
      fillSlot(el, entry);
    }
  }

  function fetchBatch(skuSlice, slots) {
    var url = PROXY + '?action=prices&skus=' + encodeURIComponent(skuSlice.join(','));
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        if (!json || json.ok !== true || json.authorized !== true) {
          markUnauthorized(slots);
          return;
        }
        applyPrices(json.prices || {}, slots);
      })
      .catch(function () {
        /* Leave "Loading partner price" in place so a later pass can retry. */
      });
  }

  function loadPrices() {
    if (inflight) {
      queued = true;
      return;
    }
    var collected = uniquePendingSkus();
    if (!collected.skus.length) return;
    inflight = true;
    var chain = Promise.resolve();
    for (var i = 0; i < collected.skus.length; i += BATCH) {
      var slice = collected.skus.slice(i, i + BATCH);
      chain = chain.then(
        function (skuSlice) {
          return fetchBatch(skuSlice, collected.slots);
        }.bind(null, slice)
      );
    }
    chain
      .then(function () {
        inflight = false;
        if (queued) {
          queued = false;
          loadPrices();
        }
      })
      .catch(function () {
        inflight = false;
      });
  }

  function scheduleLoad() {
    clearTimeout(timer);
    timer = setTimeout(loadPrices, 50);
  }

  function observeGrids() {
    var root = document.querySelector('results-list, .product-grid, main, body');
    if (!root || root.getAttribute('data-lpe-price-observer') === '1') return;
    root.setAttribute('data-lpe-price-observer', '1');
    var observer = new MutationObserver(function () {
      scheduleLoad();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleLoad();
    observeGrids();
  });
  document.addEventListener('shopify:section:load', scheduleLoad);
  document.addEventListener('shopify:section:reorder', scheduleLoad);
  if (document.readyState !== 'loading') {
    scheduleLoad();
    observeGrids();
  }
})();
